import React from 'react';

const PlatformSection = () => {
    const platforms = [
        {
            id: 'bigcommerce',
            name: 'BigCommerce',
            class: 'bigcommerce',
            skills: [
                'Stencil CLI & Theme Development',
                'Storefront API & GraphQL integration',
                'Custom app development & integrations',
                'B2B Edition configurations',
                'Performance optimization & caching strategies',
                'Multi-storefront architecture'
            ]
        },
        {
            id: 'magento',
            name: 'Magento 2',
            class: 'magento',
            skills: [
                'Custom module development',
                'Checkout optimization & customization',
                'Theme implementation and customization',
                'PWA Studio & headless architecture',
                'Performance tuning & full-page caching',
                'Adobe Commerce Cloud deployments'
            ]
        },
        {
            id: 'shopware',
            name: 'Shopware 6',
            class: 'shopware',
            skills: [
                'Storefront plugin development',
                'Twig template customization',
                'Custom plugin architecture',
                'API-first & headless implementations',
                'Shopping Experiences & CMS customization',
                'Performance optimization & caching'
            ]
        },
        {
            id: 'woocommerce',
            name: 'WooCommerce',
            class: 'woocommerce',
            skills: [
                'Custom theme development',
                'Plugin development & customization',
                'Multi-vendor marketplace setups',
                'Subscription & membership systems',
                'Payment gateway integrations',
                'Performance optimization & scaling'
            ]
        }
    ];

    return (
        <section className="section platform-section">
            <div className="container">
                <h2 className="section-title">Platform Expertise</h2>
                <p className="section-subtitle">
                    Deep technical knowledge across the leading ecommerce platforms
                </p>

                <div className="platforms-grid grid grid--3">
                    {platforms.map((platform) => (
                        <div key={platform.id} className={`platform-card platform-card--${platform.class}`}>
                            <div className="platform-card__header">
                                <div className="platform-card__icon">
                                    {platform.name.charAt(0)}
                                </div>
                                <h3 className="platform-card__title">{platform.name}</h3>
                            </div>
                            <ul className="platform-card__list">
                                {platform.skills.map((skill, index) => (
                                    <li key={index} className="platform-card__item">
                                        {skill}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PlatformSection;